module.exports = __webpack_public_path__ + "img/Hammock-8K-Fn2.acb9d1a8.gif";